import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { GasFileUploaderComponent } from './gas-file-uploader.component';
import { GasUploaderDirectiveModule } from '../../utils/gas-uploader-directive/gas-uploader-directive.module';
import { GasButtonModule } from './../../forms/gas-button/gas-button.module';
import { GasProgressBarModule } from '../gas-progress-bar/progress-bar.module';

const COMPONENTS = [
  GasFileUploaderComponent,
];

@NgModule({
  declarations: [
    COMPONENTS,
  ],
  exports: [
    COMPONENTS,
  ],
  imports: [
    CommonModule,

    GasUploaderDirectiveModule,
    GasButtonModule,
    GasProgressBarModule,
  ],
})
export class GasFileUploaderModule { }
